export default __webpack_public_path__ + "static/media/75.a473ac3d.png";